import { Component, Input, OnInit } from '@angular/core';
import { FormService } from '../../../common/services/form.service';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { Field } from 'src/sb-tools/typescript/models/field.model';
import { ClientField } from '../../../common/models/client-field.model';
import { NgClass } from '@angular/common';

@Component({
    selector: 'sb-form-header',
    templateUrl: './form-header.component.html',
    styleUrls: ['./form-header.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    imports: [FormsModule, NgClass],
})
export class FormHeaderComponent implements OnInit {
    @Input() formField: Field | ClientField;

    isImageHidden = false;

    constructor(public formService: FormService) {}

    ngOnInit() {
        this.isImageHidden = this.formField.options?.isImageHidden === 'true';
    }
}
